import { commitLocalUpdate, type useRelayEnvironment } from 'react-relay/hooks';
import type { RecordSourceSelectorProxy } from 'relay-runtime';

export const TEMP_CREATE_FIELDSET_ID = 'temp_new_fieldset_id';

export const updateTempOptimisticFieldSetId = ({
	environment,
	fieldConfigId,
	fieldSetId,
}: {
	fieldConfigId: string | undefined;
	environment: ReturnType<typeof useRelayEnvironment>;
	fieldSetId: string;
}) => {
	commitLocalUpdate(environment, (store: RecordSourceSelectorProxy) => {
		if (fieldConfigId) {
			const fields = store.get(fieldConfigId)?.getLinkedRecords('edges');

			const currentField = fields?.find(
				(edge) => edge.getLinkedRecord('node')?.getValue('fieldSetId') === TEMP_CREATE_FIELDSET_ID,
			);

			if (currentField) {
				currentField.getLinkedRecord('node')?.setValue(fieldSetId, 'fieldSetId');
			}
		}
	});
};

export const updateOptimisticField = ({
	environment,
	fieldConfigId,
	field: { fieldId, fieldSetId, name },
}: {
	fieldConfigId: string | undefined;
	environment: ReturnType<typeof useRelayEnvironment>;
	field: { fieldId: string; fieldSetId: string; name: string };
}) => {
	commitLocalUpdate(environment, (store: RecordSourceSelectorProxy) => {
		if (fieldConfigId) {
			const fields = store.get(fieldConfigId)?.getLinkedRecords('edges');
			const currentField = fields?.find((edge) => {
				const metadata = edge.getLinkedRecord('node')?.getLinkedRecord('fieldsMetadata');
				const fsFields = metadata?.getLinkedRecords('edges');
				const fsField = fsFields?.find(
					(fedge) => fedge?.getLinkedRecord('node')?.getValue('fieldId') === fieldId,
				);
				return !!fsField;
			});
			if (currentField) {
				currentField.getLinkedRecord('node')?.setValue(fieldSetId, 'fieldSetId');
				currentField.getLinkedRecord('node')?.setValue(name, 'displayName');
			}
		}
	});
};
